export default {
  install(Vue) {
    // 动态加载GrowingIO
    const loadGrowingIO = () => {
      window.gio = window.gio || function(){(window.gio.q=window.gio.q||[]).push(arguments)};
      const script = document.createElement('script');
      script.src = 'https://assets.giocdn.com/2.1/gio.js';
      script.async = true;
      document.head.appendChild(script);
      
      window.gio('init', 'b0d18e1f996f733e', {});
      window.gio('send');
    };
    
    // 添加到Vue原型
    Vue.prototype.$growingio = window.gio;
    // loadGrowingIO();
    // 生产环境自动加载
    if (process.env.NODE_ENV === 'production') {
      loadGrowingIO();
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./scripts/growingio.js
// module id = null
// module chunks = 